/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */

export interface LocaleRoutes {
  account: string;
  blueLightCard: string;
  exploreMenu: string;
  signUp: string;
  signIn: string;
  storeLocator: string;
  userPreferencesModal: string;
  membershipDetails: string;
}

export const localeRoutes: Record<string, LocaleRoutes> = {
  ar: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  ca: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  cs: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  de: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  en: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  es: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  eu: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  fr: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  gl: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  it: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  ko: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  nl: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  pl: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  pt: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
  ro: {
    account: '/account',
    blueLightCard: '/account/memberships/details/blue-light-card',
    exploreMenu: '/explore-menu',
    membershipDetails: '/account/memberships/details',
    signUp: '/signup',
    signIn: '/signin',
    storeLocator: '/store-locator',
    userPreferencesModal: '/user-preferences-modal',
  },
};
